import {
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
  Theme,
} from '@mui/material';

type MuiDialog = {
  styleOverrides?: ComponentsOverrides<Theme>['MuiDialog'];
  defaultProps?: ComponentsProps['MuiDialog'];
  variants?: ComponentsVariants['MuiDialog'];
};

type MuiDialogActions = {
  styleOverrides?: ComponentsOverrides<Theme>['MuiDialogActions'];
  defaultProps?: ComponentsProps['MuiDialogActions'];
  variants?: ComponentsVariants['MuiDialogActions'];
};

type MuiDialogContent = {
  styleOverrides?: ComponentsOverrides<Theme>['MuiDialogContent'];
  defaultProps?: ComponentsProps['MuiDialogContent'];
  variants?: ComponentsVariants['MuiDialogContent'];
};

type MuiDialogTitle = {
  styleOverrides?: ComponentsOverrides<Theme>['MuiDialogTitle'];
  defaultProps?: ComponentsProps['MuiDialogTitle'];
  variants?: ComponentsVariants['MuiDialogTitle'];
};

export const MuiDialog: MuiDialog = {
  styleOverrides: {
    paper: {
      boxShadow:
        '0px 4px 14px rgba(0, 0, 0, 0.2), 0px 3px 14px rgba(0, 0, 0, 0.12), 0px 8px 10px rgba(0, 0, 0, 0.14)',
    },
    paperWidthSm: {
      maxWidth: 684,
    },
    paperFullScreen: {
      maxWidth: 'none',
    },
  },
};

const dialogShadow =
  '0px 1px 10px rgba(0, 0, 0, 0.2), 0px 4px 5px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.14)';

export const MuiDialogActions: MuiDialogActions = {
  styleOverrides: {
    root: {
      justifyContent: 'center',
      padding: '14px 24px',
      '&.shadow': {
        boxShadow: dialogShadow,
      },
    },
  },
};

export const MuiDialogContent: MuiDialogContent = {
  styleOverrides: {
    root: {
      padding: '0px 24px',
    },
  },
};

export const MuiDialogTitle: MuiDialogTitle = {
  styleOverrides: {
    root: {
      position: 'relative',
      zIndex: 1,
      '&.shadow': {
        boxShadow: dialogShadow,
      },
    },
  },
};
